import { Mail, MessageCircle, MapPin } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { OWNER } from "@/data/villas";
import BookingForm from "@/components/BookingForm";
import SEO from "@/components/SEO";

export default function Contact() {
  const { t } = useLang();
  return (
    <>
      <SEO pageKey="contact" />
      <section className="dh-container pt-16 pb-8">
        <div className="dh-overline">{t.contact.overline}</div>
        <h1 className="font-serif text-5xl md:text-6xl mt-4">{t.contact.title}</h1>
        <p className="mt-4 text-[color:hsl(var(--dh-muted))]">{t.contact.subtitle}</p>
      </section>

      <section className="dh-container pb-16 grid md:grid-cols-4 gap-6">
        <a href={`tel:+212718115419`} data-testid="contact-phone" className="dh-card p-8 hover:border-[color:hsl(var(--dh-terracotta))] transition-colors">
          <MessageCircle className="h-5 w-5 text-[color:hsl(var(--dh-terracotta))]" />
          <div className="dh-overline mt-4">{t.contact.phone}</div>
          <div className="font-serif text-2xl mt-2">+212 7 18 11 54 19</div>
        </a>
        <a href={OWNER.waLink} target="_blank" rel="noreferrer" data-testid="contact-whatsapp" className="dh-card p-8 hover:border-[color:hsl(var(--dh-terracotta))] transition-colors">
          <MessageCircle className="h-5 w-5 text-[color:hsl(var(--dh-terracotta))]" />
          <div className="dh-overline mt-4">{t.contact.whatsapp}</div>
          <div className="font-serif text-2xl mt-2">+212 7 18 11 54 19</div>
        </a>
        <a href={`mailto:${OWNER.email}`} data-testid="contact-email" className="dh-card p-8 hover:border-[color:hsl(var(--dh-terracotta))] transition-colors">
          <Mail className="h-5 w-5 text-[color:hsl(var(--dh-terracotta))]" />
          <div className="dh-overline mt-4">{t.contact.email}</div>
          <div className="font-serif text-xl mt-2 break-all">{OWNER.email}</div>
        </a>
        <div className="dh-card p-8">
          <MapPin className="h-5 w-5 text-[color:hsl(var(--dh-terracotta))]" />
          <div className="dh-overline mt-4">{t.contact.address}</div>
          <div className="font-serif text-2xl mt-2">{t.contact.addressValue}</div>
        </div>
      </section>

      <section className="dh-container pb-24">
        <div className="max-w-xl mb-10">
          <div className="dh-overline">{t.booking.overline}</div>
          <h2 className="font-serif text-4xl md:text-5xl mt-4">{t.booking.title}</h2>
        </div>
        <BookingForm />
      </section>
    </>
  );
}
